import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ConsentProvider"] */ "/app/core/components/providers/ConsentProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteConfigProvider"] */ "/app/core/components/providers/SiteConfigProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TranslationProvider"] */ "/app/core/components/providers/TranslationProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/core/components/ui/toaster.tsx");
